module.exports = __webpack_public_path__ + "static/about-1-5863739466690ad4af782938401e7bde.jpg";